export const GET_STATS__REQUEST = 'STATS_TYPE__GET_STATS__REQUEST';
export const GET_STATS__SUCCESS = 'STATS_TYPE__GET_STATS__SUCCESS';
export const GET_STATS__FAILURE = 'STATS_TYPE__GET_STATS__FAILURE';
